import { AuthCode, AuthResult } from '../model/auth.model';
import { FirebaseError } from 'firebase/app';

export function convertFirebaseError(error: any, code: string): AuthResult {
  const result: AuthResult = {
    code: AuthCode.unknown,
    error: error as FirebaseError,
  };
  switch (code) {
    case 'auth/invalid-action-code':
    case 'INVALID_OOB_CODE':
      result.code = AuthCode.codeInvalid;
      break;
    case 'auth/wrong-password':
    case 'auth/invalid-login-credentials':
    case 'auth/invalid-credential':
    case 'INVALID_PASSWORD': // Firebase Emulator Erreur
    case 'INVALID_LOGIN_CREDENTIALS': // Firebase Emulator Erreur
      result.code = AuthCode.failure;
      break;
    case 'auth/too-many-requests':
    case 'TOO_MANY_ATTEMPTS_TRY_LATER': // Firebase Emulator Erreur
      result.code = AuthCode.tooManyRequest;
      break;
    case 'auth/missing-android-pkg-name':
    case 'auth/missing-continue-uri':
    case 'auth/missing-ios-bundle-id':
    case 'auth/invalid-continue-uri':
    case 'auth/unauthorized-continue-uri':
    default:
      result.code = AuthCode.unknown;
      break;
  }

  return result;
}
